import { Component, OnInit } from '@angular/core';
import { FakDokumentUplata } from './fak-dokument-uplata';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContainerService, BaseModalUpdateComponent, ModalService } from 'yt-ng-framework';

@Component({
  selector: 'yt-fak-dokument-uplata-modal-update',
  templateUrl: './fak-dokument-uplata-modal-update.component.html'
})
export class FakDokumentUplataModalUpdateComponent extends BaseModalUpdateComponent<FakDokumentUplata> {

  constructor(
    protected modalContainerService: ModalContainerService<FakDokumentUplata>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  

}
